import {Pipe, PipeTransform} from '@angular/core';
import {Settings} from '../settings.class';

@Pipe({
    name: 'hectoPinIcon'
})
export class HectoPinIconPipe implements PipeTransform {
    transform(hectoPin: any): any {
        const parser = new DOMParser();

        const svg = Settings.getHecto(hectoPin.waynumber, hectoPin.hectometre, (hectoPin.direction ?? hectoPin.letter));
        return parser.parseFromString(svg, 'image/svg+xml').documentElement;
    }
}
